import React from 'react';
import { IconBase, IconBaseProps } from './IconBase';

export const House: React.FunctionComponent<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 50 50">
    <path
      d="m1059.53906 158.121094h46.76953v5.179687h-46.76953zm5.17969-20.820313h5.17969v15.589844h-5.17969zm20.82031 10.410157h15.58985v5.179687h-15.58985zm0-10.410157h15.58985v5.179688h-15.58985zm-10.41015 0h5.17968v15.589844h-5.17968zm29.75781-3.046875-21.88672-14.625-22.03906 14.625-2.84375-4.316406 21.9375-14.625c.40625-.270835.85481-.482421 1.3457-.634766.49089-.152344.99023-.228515 1.49805-.228515.54167 0 1.05794.076171 1.54883.228515.49088.152345.95637.363931 1.39648.634766h-.05078l21.98828 14.625z"
      transform="translate(-1058 -114)"
    />
  </IconBase>
);
